export const COLLECTION_DENSIDADE_IN_SITU = "tblDensidadeInSitu";

export function numero(valor) {
  if (valor === null || valor === undefined || valor === "") return null;
  const tratado = String(valor).replace(/\./g, "").replace(",", ".");
  const convertido = Number(tratado);
  return Number.isFinite(convertido) ? convertido : null;
}

export function formatarNumero(valor, casas = 3) {
  if (valor === null || valor === undefined || valor === "") return "";
  const convertido = typeof valor === "number" ? valor : numero(valor);
  if (convertido === null) return "";
  return convertido.toFixed(casas).replace(".", ",");
}

export function formatarDataBR(dataISO) {
  if (!dataISO) return "-";
  const [ano, mes, dia] = String(dataISO).split("-");
  if (!ano || !mes || !dia) return dataISO;
  return `${dia}/${mes}/${ano}`;
}

export function criarEnsaiosInSitu(qtd = 4) {
  return Array.from({ length: qtd }, (_, index) => ({
    id: index + 1,
    numero: index === 0 ? "1" : "",
    localizacao: "",
    hora: "",
    camadaCota: "",
    profundidade: "",
    frascoAreia: "",
    pesoInicialFrasco: "",
    pesoFinalFrasco: "",
    pesoDeslocado: "",
    pesoAreiaFunil: "",
    pesoAreiaFuro: "",
    densidadeAreia: "",
    volumeFuro: "",
    pesoSoloTara: "",
    pesoTara: "",
    pesoSoloUmido: "",
    umidadeSolo: "",
    pesoSoloSeco: "",
    densidadeSoloSeco: "",
    densidadeMaxima: "",
    umidadeOtima: "",
    grauCompactacao: "",
    conforme: false,
    naoConforme: false,
  }));
}

export const estadoInicialDensidadeInSitu = {
  codigo: "",
  compactacaoId: "",
  compactacaoCodigo: "",
  empresa: "",
  cliente: "",
  clienteId: "",
  obra: "",
  obraId: "",
  camadaEstudo: "",
  operador: "",
  calculista: "",
  dataEnsaio: "",
  laboratorio: "",
  fiscalizacao: "",
  observacao: "",
  ensaios: criarEnsaiosInSitu(),
};

export function calcularEnsaioInSitu(ensaio) {
  const pesoInicial = numero(ensaio.pesoInicialFrasco);
  const pesoFinal = numero(ensaio.pesoFinalFrasco);
  const pesoAreiaFunil = numero(ensaio.pesoAreiaFunil);
  const densidadeAreia = numero(ensaio.densidadeAreia);
  const pesoSoloTara = numero(ensaio.pesoSoloTara);
  const pesoTara = numero(ensaio.pesoTara);
  const umidadeSolo = numero(ensaio.umidadeSolo);
  const densidadeMaxima = numero(ensaio.densidadeMaxima);

  const pesoDeslocado =
    pesoInicial !== null && pesoFinal !== null ? pesoInicial - pesoFinal : null;
  const pesoAreiaFuro =
    pesoDeslocado !== null && pesoAreiaFunil !== null ? pesoDeslocado - pesoAreiaFunil : null;
  const volumeFuro =
    pesoAreiaFuro !== null && densidadeAreia ? pesoAreiaFuro / densidadeAreia : null;
  const pesoSoloUmido =
    pesoSoloTara !== null && pesoTara !== null ? pesoSoloTara - pesoTara : null;
  const pesoSoloSeco =
    pesoSoloUmido !== null && umidadeSolo !== null ? (pesoSoloUmido / (100 + umidadeSolo)) * 100 : null;
  const densidadeSoloSeco =
    pesoSoloSeco !== null && volumeFuro ? pesoSoloSeco / volumeFuro : null;
  const grauCompactacao =
    densidadeSoloSeco !== null && densidadeMaxima ? (densidadeSoloSeco / densidadeMaxima) * 100 : null;

  return {
    ...ensaio,
    pesoDeslocado: pesoDeslocado === null ? ensaio.pesoDeslocado || "" : formatarNumero(pesoDeslocado, 0),
    pesoAreiaFuro: pesoAreiaFuro === null ? ensaio.pesoAreiaFuro || "" : formatarNumero(pesoAreiaFuro, 0),
    volumeFuro: volumeFuro === null ? ensaio.volumeFuro || "" : formatarNumero(volumeFuro, 0),
    pesoSoloUmido: pesoSoloUmido === null ? ensaio.pesoSoloUmido || "" : formatarNumero(pesoSoloUmido, 0),
    pesoSoloSeco: pesoSoloSeco === null ? ensaio.pesoSoloSeco || "" : formatarNumero(pesoSoloSeco, 0),
    densidadeSoloSeco:
      densidadeSoloSeco === null ? ensaio.densidadeSoloSeco || "" : formatarNumero(densidadeSoloSeco, 3),
    grauCompactacao:
      grauCompactacao === null ? ensaio.grauCompactacao || "" : formatarNumero(grauCompactacao, 1),
    conforme: Boolean(ensaio.conforme),
    naoConforme: Boolean(ensaio.naoConforme),
  };
}

export function recalcularDensidadeInSitu(form) {
  return {
    ...form,
    ensaios: (form.ensaios || criarEnsaiosInSitu()).map(calcularEnsaioInSitu),
  };
}

export function calcularProximoCodigoInSitu(lista) {
  const ano = new Date().getFullYear();
  const numeros = lista
    .map((item) => String(item.codigo || "").match(/RE-DI-(\d+)\/\d{4}/))
    .filter(Boolean)
    .map((match) => Number(match[1]))
    .filter(Number.isFinite);
  const proximo = numeros.length ? Math.max(...numeros) + 1 : lista.length + 1;
  return `RE-DI-${String(proximo).padStart(3, "0")}/${ano}`;
}
